var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCleanout = function SvgCleanout(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7 13.875 16 7l9 6.875L21.562 25H10.438zm9 7.268a3.857 3.857 0 1 0 0-7.714 3.857 3.857 0 0 0 0 7.714",
    clipRule: "evenodd"
  })));
};
export { SvgCleanout as ReactComponent };
export default "data:image/svg+xml,%3csvg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cpath fill-rule='evenodd' clip-rule='evenodd' d='M7 13.8754L16 7L25 13.8754L21.5623 25L10.4377 25L7 13.8754ZM16 21.1429C18.1302 21.1429 19.8571 19.416 19.8571 17.2858C19.8571 15.1556 18.1302 13.4286 16 13.4286C13.8697 13.4286 12.1428 15.1556 12.1428 17.2858C12.1428 19.416 13.8697 21.1429 16 21.1429Z' fill='%234A6067'/%3e %3c/svg%3e";